module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-toolbar', {
    staticClass: "teal white--text"
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.$t('profile.common.title')))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.save
    }
  }, [_c('v-icon', [_vm._v("check")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('v-alert', {
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "top": "0px",
      "width": "100%",
      "z-index": "1"
    },
    attrs: {
      "dismissible": "",
      "transition": "fade-transition",
      "success": "",
      "value": _vm.saved
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('profile.common.saved')) + "\n    ")]), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('headers.personName')
    },
    model: {
      value: (_vm.value.name),
      callback: function($$v) {
        _vm.$set(_vm.value, "name", $$v)
      },
      expression: "value.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('headers.surname')
    },
    model: {
      value: (_vm.value.surname),
      callback: function($$v) {
        _vm.$set(_vm.value, "surname", $$v)
      },
      expression: "value.surname"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('headers.email')
    },
    model: {
      value: (_vm.value.email),
      callback: function($$v) {
        _vm.$set(_vm.value, "email", $$v)
      },
      expression: "value.email"
    }
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00087098","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile/Common.vue
// module id = 1045
// module chunks = 1